import React, { useState, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';

import { Field, ErrorMessage, useField, useFormikContext } from 'formik';
import { Select } from 'formik-material-ui';
import {
  FormControl,
  InputLabel,
  MenuItem,
  FormHelperText,
} from '@material-ui/core';

import { usePermissionGroupGetListByCategoryLevel } from './../../../hooks/useData';

// TODO: Hook permissionGroups api

/**
 * SelectPermissionGroup() (component)
 * @param {string} name, name of select element (default: category_id)
 * @param {string} id, id of select element (default: category_id)
 * @param {string} label, label of select element (default: "ประเภทของข้อมูลส่วนบุคคลที่มีการละเมิด")
 * @param {string} categoryId, category id
 * @param {number} level, level 1|2|3
 * @param {function} onChange, onChange
 * @param {bool} disabled, default: false
 * @param {object} className, className of select element
 * @param variant
 * @returns (element) SelectPermissionGroup
 */
const SelectPermissionGroup = ({
  name = 'permissionGroup_id',
  id = 'permissionGroup_id',
  label = 'กลุ่มผู้ดูแลข้อมูล',
  categoryId = null,
  level = null,
  disabled = false,
  onChange,
  className,
  variant = 'standard',
}) => {
  // Hook Formik setFildValue
  const { setFieldValue } = useFormikContext();
  // https://formik.org/docs/api/useField (Test value from formik, instead state-value)
  const [field, meta] = useField(name);

  const permissionGroups = usePermissionGroupGetListByCategoryLevel(
    categoryId,
    level
  );
  const havePermissionGroups = permissionGroups
    ? permissionGroups.length > 0
    : false;

  // Handle change select
  const memoHandleChange = useCallback((e, c) => {
    setFieldValue(name, e.target.value);
    let context = typeof c.props.children === 'string' ? c.props.children : '';
    onChange && onChange(e, context);
  });

  return (
    <React.Fragment>
      <FormControl
        fullWidth
        error={meta.error && meta.touched}
        className={className}
        variant={variant}
        size="small"
      >
        <InputLabel htmlFor={id} style={{ backgroundColor: 'white' }}>{label}</InputLabel>
        <Field
          component={Select}
          name={name}
          inputProps={{
            id,
            name,
          }}
          onChange={memoHandleChange}
          disabled={disabled || !havePermissionGroups}
        >
          <MenuItem value="">
            <em>เลือก {label}</em>
          </MenuItem>
          {permissionGroups.map((permissionGroup) => (
            <MenuItem value={permissionGroup.id} key={permissionGroup.id}>
              {permissionGroup.name}
            </MenuItem>
          ))}
        </Field>
        <ErrorMessage name={name} component={FormHelperText}></ErrorMessage>
      </FormControl>
    </React.Fragment>
  );
};

// Types[, Rules] of props
SelectPermissionGroup.propTypes = {
  name: PropTypes.string,
  id: PropTypes.string,
  label: PropTypes.string,
  onChange: PropTypes.func,
};

export default React.memo(SelectPermissionGroup);
